import { useForm } from "react-hook-form";
import styles from "./Details.module.css";
import { Input } from "../../../../common/Input";
import { Button } from "../../../../common/Button";
import { ButtonFooter } from "../../../../common/ButtonFooter";

export const Details = ({
  email,
  fullName,
  onContinue,
  isLoading,
}: {
  email: string;
  fullName: string;
  onContinue?: () => void;
  isLoading?: boolean;
}) => {
  const { register, handleSubmit } = useForm();

  const handleFormSubmit = onContinue || (() => {});

  return (
    <div className={styles.container}>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className={styles.form}>
          <Input
            register={register}
            inputId="fullname"
            value={fullName}
            disabled={true}
            type="text"
            label="Full name"
            placeholder="Full name"
          />
          <Input
            register={register}
            inputId="email"
            value={email}
            disabled={true}
            type="email"
            label="Email address"
            placeholder="Email address"
          />
        </div>

        <ButtonFooter>
          <Button
            type="submit"
            text="Continue"
            buttonStyle="primary"
            disabled={isLoading}
            isButtonLoading={isLoading}
          />
        </ButtonFooter>
      </form>
    </div>
  );
};
